import script from "./time-ago.vue?vue&type=script&lang=ts&setup=true"
export * from "./time-ago.vue?vue&type=script&lang=ts&setup=true"

import "./time-ago.vue?vue&type=style&index=0&id=4cc5a2c7&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cc5a2c7"]])

export default __exports__